import React from "react";
import {Box, Button, Menu, MenuItem, Stack, Typography} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
      <Stack spacing={2} p={3}>
        <Box>
          <Typography variant={"h6"} color={"text.primary"}>
            Basic menu
          </Typography>
          <Typography variant={"body2"} color={"text.primary"}>
            A basic menu opens over the anchor element by default (this option can be changed via props). When close to a screen edge, a basic menu vertically realigns to make sure that all menu items are completely visible.
          </Typography>
        </Box>
        <Box sx={{ width: "80%", alignSelf: "center" }}>
      <PreviewAndEditor
        language="js"
        title={"Basic menu"}
        value={
          'import {Button, Menu, MenuItem } from "@mui/material";\n\n\n' +
          " const [anchorEl, setAnchorEl] = React.useState(null);\n" +
          "  const open = Boolean(anchorEl);\n" +
          "  const handleClick = (event) => {\n" +
          "    setAnchorEl(event.currentTarget);\n" +
          "  };\n" +
          "  const handleClose = () => {\n" +
          "    setAnchorEl(null);\n" +
          "  };\n\n\n" +
          "<Button\n" +
          '          id="basic-button"\n' +
          '          aria-controls={open ? "basic-menu" : undefined}\n' +
          '          aria-haspopup="true"\n' +
          '          aria-expanded={open ? "true" : undefined}\n' +
          "          onClick={handleClick}\n" +
          "        >\n" +
          "          Dashboard\n" +
          "        </Button>\n" +
          "        <Menu\n" +
          '          id="basic-menu"\n' +
          "          anchorEl={anchorEl}\n" +
          "          open={open}\n" +
          "          onClose={handleClose}\n" +
          "          MenuListProps={{\n" +
          '            "aria-labelledby": "basic-button",\n' +
          "          }}\n" +
          "\n" +
          "        >\n" +
          "          <MenuItem onClick={handleClose}>Profile</MenuItem>\n" +
          "          <MenuItem onClick={handleClose}>My account</MenuItem>\n" +
          "          <MenuItem onClick={handleClose}>Logout</MenuItem>\n" +
          "        </Menu>"
        }
      >
        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          Dashboard
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={handleClose}>Profile</MenuItem>
          <MenuItem onClick={handleClose}>My account</MenuItem>
          <MenuItem onClick={handleClose}>Logout</MenuItem>
        </Menu>
      </PreviewAndEditor>
    </Box>
      </Stack>
  );
};

export default BasicMenu;
